import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://localhost:5000/api/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      console.log("Server Response:", data);

      if (data.success) {
        toast.success(
          "Thank you for contacting us. Our team will get back to you shortly.",
        );

        // Optional: Clear form
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error(data.msg || "Failed to submit enquiry.");
      }
    } catch (error) {
      console.log("Error:", error);

      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <section id="contact" className="py-5 bg-white">
      <Container className="py-5">
        {/* 1. Header Block */}
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <h2 className="font-rozha display-6 fw-bold text-success mb-3">
              Get In Touch
            </h2>
            <p className="text-secondary px-lg-5 fs-6 lh-base">
              We thrive when coming up with innovative ideas but also understand
              that a smart concept should be supported with measurable results.
            </p>
          </Col>
        </Row>

        {/* 2. Form Content Block (Wrapped in a proper row to center it) */}
        <Row className="justify-content-center">
          <Col lg={8} md={10} xs={12}>
            {" "}
            {/* Set to 8 columns wide and fully responsive */}
            <Form
              onSubmit={handleSubmit}
              className="shadow-sm p-4 p-md-5  bg-white"
            >
              {/* Nested Name and Email row side-by-side */}
              <Row className="mb-4 g-3">
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-dark mb-2">
                      Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Your name*"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="border-1 py-2.5 px-3 rounded shadow-none"
                      style={{ backgroundColor: "#f3f6f9" }}
                    />
                  </Form.Group>
                </Col>

                <Col sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-dark mb-2">
                      Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Your email*"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="border-1 py-2.5 px-3 rounded shadow-none"
                      style={{ backgroundColor: "#f3f6f9" }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Subject Input Field */}
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold text-dark mb-2">
                  Subject
                </Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  placeholder="Your Subject.."
                  value={formData.subject}
                  onChange={handleChange}
                  className="border-1 py-2.5 px-3 rounded shadow-none"
                  style={{ backgroundColor: "#f3f6f9" }}
                />
              </Form.Group>

              {/* Message Textarea Box */}
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold text-dark mb-2">
                  Message
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={4}
                  placeholder="Your message..."
                  value={formData.message}
                  onChange={handleChange}
                  className="border-1 py-2.5 px-3 rounded shadow-none"
                  style={{ backgroundColor: "#f3f6f9", resize: "none" }}
                />
              </Form.Group>

              {/* Send Button aligned to the right side of the container */}
              <div className="text-end">
                <Button
                  type="submit"
                  style={{ backgroundColor: "#405189", borderColor: "#405189" }}
                  className="px-4 py-2.5 fw-medium shadow-sm rounded"
                >
                  Send Message
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
} 


